
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 21.477h23m-21-12v12m19 0v-12m2-1.672a.5.5 0 00-.3-.458l-11-4.783a.5.5 0 00-.4 0L.8 7.347a.5.5 0 00-.3.458v1.172a.5.5 0 00.5.5h22a.5.5 0 00.5-.5V7.805zM5 21.477a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v9a.5.5 0 01-.146.354.5.5 0 01-.354.146m-12.5-7h11m-11 2h11m-11 2h11","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    